module.exports = __webpack_public_path__ + "img/api-management-platforms.66c568dd.svg";